import { LocalDate } from '@js-joda/core';
import { Effect, Option, Schema, SchemaGetter, SchemaIssue } from 'effect';

import { formatUnknown } from '../helper';
import { StringRequired } from './string';

export const LocalDateClass = Schema.declare(
  (input: unknown): input is LocalDate => input instanceof LocalDate
).annotate({
  identifier: 'LocalDate',
  message: 'Očekává se instance typu „LocalDate“.',
});

export const LocalDateFromString = StringRequired.pipe(
  Schema.decodeTo(LocalDateClass, {
    decode: SchemaGetter.transformEffect((input: string) =>
      Effect.try({
        try: () => LocalDate.parse(input),
        catch: () =>
          new SchemaIssue.InvalidValue({
            message: `Hodnota ${formatUnknown(input)} musí být v platném formátu RRRR-MM-DD`,
          }),
      })
    ),
    encode: SchemaGetter.transform((localDate) => localDate.toString()),
  })
);
